module.exports = __webpack_public_path__ + "static/fonts/DISPLAY.f07da7a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/DISPLAY.ttf
// module id = OmfV
// module chunks = 1